import AdModel from "../../domain/models/ad.model";
import FileUpload from "../../domain/models/fileUpload.model";
import AdService from "../../infraestructure/services/ad.service";
import ErrorsUtil from "../../infraestructure/utils/errors.util";
import { DEFAULT_ERROR_MESSAGE } from "../../shared/static/constants.static";


const useAdFunctions = () => {
    const adService = new AdService();

    const getAllAds = async (): Promise<AdModel[]> => {

        try {
            const response = await adService.getAllAds();
            if (!response) throw new Error(DEFAULT_ERROR_MESSAGE)
            return response;
        } catch (error) {
            ErrorsUtil.manageError(error)
            throw error;
        }
    }

    const createAd = async (ad: AdModel): Promise<AdModel> => {
        try {
            const response = await adService.createAd(ad);
            if (!response) throw new Error(DEFAULT_ERROR_MESSAGE)
            return response;
        } catch (error) {
            ErrorsUtil.manageError(error)
            throw error;
        }
    }

    const updateAd = async (ad: AdModel): Promise<AdModel> => {
        try {
            const response = await adService.updateAd(ad);
            if (!response) throw new Error(DEFAULT_ERROR_MESSAGE)
            return response;
        } catch (error) {
            ErrorsUtil.manageError(error)
            throw error;
        }
    }

    const deleteAd = async (id: number): Promise<void> => {
        try {
            await adService.deleteAd(id);
        } catch (error) {
            ErrorsUtil.manageError(error)
            throw error;
        }
    }

    const uploadAdImage = async (file: File): Promise<FileUpload> => {
        try {
            const response = await adService.uploadAdImage(file);
            if (!response) throw new Error(DEFAULT_ERROR_MESSAGE)
            return response;
        } catch (error) {
            ErrorsUtil.manageError(error)
            throw error;
        }
    }

    return {
        getAllAds,
        createAd,
        updateAd,
        deleteAd,
        uploadAdImage
    }
}

export default useAdFunctions;